// libs
import Tile from '@/widgets/Tile/Tile';
import React from 'react';
import cx from 'classnames';
//dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { RadioGroup } from '@swiggy-private/dls-web-core/dist/components/RadioGroup';
import { RightActionTypes, TextFieldTypes, } from '@swiggy-private/dls-web-core/dist/components/TextField/types';
import DlsTextField from '@/widgets/DlsTextFeild';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// stores
import useWriteCampaignStore from '@/stores/WriteCampaign';
// styles
import style from './Budget.module.scss';
const Budget = ({ mode, currentCampaign }) => {
    const { budget, setBudget, pacingEnabled, setPacingEnabled, validationMessages, isValid, } = useWriteCampaignStore((store) => ({
        budget: store.budget,
        setBudget: store.setBudget,
        pacingEnabled: store.pacingEnabled,
        setPacingEnabled: store.setPacingEnabled,
        validationMessages: store.validationMessages,
        isValid: store.isValid,
    }));
    const onChange = (value) => {
        setBudget(Number(value));
        isValid(['budget'], {
            readCampaign: currentCampaign,
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Tile, { className: style.tile },
            React.createElement("div", { className: style.container },
                React.createElement("div", { className: style.adPaceContent },
                    React.createElement("div", { className: cx(style.description, style.float) },
                        React.createElement("div", { className: style.descriptionTitle },
                            React.createElement(Text, { variant: DlsFontVariants.header_H5_Bold, color: DlsColorTokens.text_Highest_Emphasis }, "Choose your Ad Pace")),
                        React.createElement(Text, { className: style.descriptionText, variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Med_Emphasis }, "By enabling pacing, your ads will evenly distributed across multiple days based on the number of days your campign will run for. Note that the distribution is dynamic and not uniform across each day since it depends on the number of impressions being delivered for your campaign.")),
                    React.createElement("div", { className: cx(style.radioContainer, style.float) },
                        React.createElement(RadioGroup, { name: "my-radio", value: pacingEnabled ? 'TRUE' : 'FALSE', items: [
                                { label: 'Include Ad Pace', value: 'TRUE' },
                                {
                                    label: 'Do not Include Ad Pace',
                                    value: 'FALSE',
                                },
                            ], onChange: (e) => {
                                const target = e.target;
                                setPacingEnabled(target.value === 'TRUE');
                            } }))),
                React.createElement("hr", null),
                React.createElement("div", { className: style.budgetContent },
                    React.createElement("div", { className: cx(style.description, style.float) },
                        React.createElement(Text, { variant: DlsFontVariants.header_H5_Bold, color: DlsColorTokens.text_Highest_Emphasis }, "Add Campaign Budget"),
                        React.createElement(Text, { className: style.descriptionText, variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Med_Emphasis }, "Set a budget for your campaign."))),
                React.createElement("div", { className: cx(style.budgetContent, style.float) },
                    React.createElement(Text, { variant: DlsFontVariants.header_H5_Bold, color: DlsColorTokens.text_Highest_Emphasis }, "Campaign Budget"),
                    React.createElement("div", { className: style.budgetField },
                        React.createElement(DlsTextField, { textFieldDetails: {
                                value: String(budget),
                                type: TextFieldTypes.NUMBER,
                                name: 'campaign-budget-input',
                                label: '',
                                onChange: onChange,
                                attrs: { autoComplete: 'off' },
                                containerStyle: {
                                    marginTop: '12px',
                                },
                                errorText: validationMessages.budget,
                            }, rightActionDetails: [
                                {
                                    type: RightActionTypes.CLEAR,
                                },
                            ] })))))));
};
export default Budget;
